import { writeTextOnCanvas } from './text';
import { createCanvas, createCanvasFromDataUrl, getCroppedCanvas, getScaledCanvas } from './canvas';
import { MAX_HEIGHT } from './constants';
import { SignatureFormat } from '../signature-types';
import { decodePoints } from './points';
import SignaturePad from 'signature_pad';
export function isDataUrl(dataUrl) {
  return (dataUrl == null ? void 0 : dataUrl.startsWith('data:')) ?? false;
}
export function decodeDataUrl(dataUrl) {
  if (!dataUrl) {
    return undefined;
  }
  const arr = dataUrl.split(',');
  if (arr.length < 2) {
    return undefined;
  }
  const mimeArr = arr[0].match(/:([^;]*);?(.*)$/);
  if (!mimeArr || mimeArr.length < 2) {
    return undefined;
  }
  const encoding = mimeArr[2];
  const encodedValue = arr.slice(1).join(',');
  return {
    encoding,
    type: mimeArr[1],
    value: encoding === 'base64' ? atob(encodedValue) : decodeURI(encodedValue)
  };
}
export function encodeDataUrl(data, type, encoding) {
  if (encoding === void 0) {
    encoding = 'text';
  }
  const encodedData = encoding === 'base64' ? btoa(data) : encodeURI(data);
  const typeAndEncoding = encoding === 'base64' ? `${type};base64` : type;
  return `data:${typeAndEncoding},${encodedData}`;
}
export function dataUrlToFile(dataUrl, filename) {
  const decoded = decodeDataUrl(dataUrl);
  if (!decoded) {
    return undefined;
  }
  let n = decoded.value.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = decoded.value.charCodeAt(n);
  }
  return new File([u8arr], `${filename}.${decoded.type.split('/')[1]}`, {
    type: decoded.type
  });
}
export function dataUrlToWixFile(url, displayName) {
  if (displayName === void 0) {
    displayName = 'temp';
  }
  const decoded = decodeDataUrl(url);
  return {
    fileId: 'temp',
    displayName,
    url,
    fileType: (decoded == null ? void 0 : decoded.type) ?? ''
  };
}
export async function dataUrlToPngDataUrl(dataUrl, rtl) {
  const decodedDataUrl = decodeDataUrl(dataUrl);
  if (!decodedDataUrl) {
    return dataUrl;
  }
  const dataUrlType = decodedDataUrl.type;
  if (dataUrlType === SignatureFormat.TEXT) {
    // Width doesn't matter, it will be cropped later
    const canvas = createCanvas(MAX_HEIGHT * 20, MAX_HEIGHT, 1);
    writeTextOnCanvas(canvas, decodedDataUrl.value, 'black', rtl, 'white');
    const croppedCanvas = getCroppedCanvas(canvas, 'white');
    // When cropped canvas is null it means we have an empty image ( example a transparent background )
    return (croppedCanvas == null ? void 0 : croppedCanvas.toDataURL('image/jpeg', 0.7)) ?? null;
  }
  if (dataUrlType === SignatureFormat.POINTS) {
    const points = decodePoints(dataUrl);
    if (!points) {
      return null;
    }
    const blackPoints = points.map(pointGroup => ({
      ...pointGroup,
      penColor: 'black'
    }));
    // Width doesn't matter, it will be cropped later
    const canvas = createCanvas(MAX_HEIGHT * 20, MAX_HEIGHT, Math.max(window.devicePixelRatio || 1, 1));
    const signaturePad = new SignaturePad(canvas);
    signaturePad.fromData(blackPoints);
    const croppedCanvas = getCroppedCanvas(canvas);
    if (!croppedCanvas) {
      // Empty image case
      return null;
    }
    const scaledCanvas = getScaledCanvas(croppedCanvas, undefined, MAX_HEIGHT, 'white');
    return scaledCanvas.toDataURL('image/jpeg', 0.7);
  }
  if (dataUrlType.startsWith('image/')) {
    const canvas = await createCanvasFromDataUrl(dataUrl);
    const croppedCanvas = getCroppedCanvas(canvas);
    if (!croppedCanvas) {
      // Empty image case
      return null;
    }
    const scaledCanvas = getScaledCanvas(croppedCanvas, undefined, MAX_HEIGHT);
    return scaledCanvas.toDataURL('image/jpeg', 0.7);
  }
  return dataUrl;
}
export async function processDataUrl(dataUrl, rtl) {
  const pngDataUrl = await dataUrlToPngDataUrl(dataUrl, rtl);
  if (!pngDataUrl) {
    return undefined;
  }
  return dataUrlToFile(pngDataUrl, `signature`);
}
//# sourceMappingURL=data-url.js.map